import React from 'react';
import { authAgent } from 'auth/authUtils';

const SignOut:React.FC = () => {
    authAgent.logout();
    return <></>
}

export default SignOut